import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MatTableDataSource, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'rot-dialog-alerta-zona-de-risco',
  templateUrl: './dialog-alerta-zona-risco-roteirizacao.component.html',
  styleUrls: ['./dialog-alerta-zona-risco-roteirizacao.component.scss']
})
export class DialogAlertaZonaRiscoRoteirizacaoComponent implements OnInit {

  displayedColumns: string[] = ['destino'];
  dataSource;

  constructor(public dialogRef: MatDialogRef<DialogAlertaZonaRiscoRoteirizacaoComponent>,
              @Inject(MAT_DIALOG_DATA) public listaPreCargasSelecionadas) {}


  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.listaPreCargasSelecionadas);
  }
}
